












































import { Component, Vue } from 'vue-property-decorator'
import { UserStore, userInfoTypes } from '@/store/modules/User'
import { BaseStore } from '@/store/modules/Base'

import Pdf from 'vue-pdf'

// 全局弹框协议/广告组件
@Component({
  name: 'PopUp',
  components: {
    Pdf
  }
})
export default class PopUp extends Vue {
  // 弹框显示隐藏
  // show = true

  // 定时器
  time: number | null = null

  // PDF文件链接
  pdfUrl = ''

  // PDF文件显示的总
  PageAll = 1

  // PDF文件总页数
  pdfPageAll = 1

  // PDF 当前页
  pdfPage = 1

  // 协议
  checkedAgree = false

  // 弹框 确定
  set showMold (newData) {
    BaseStore.SET_POP_UP(newData)
  }

  get showMold (): boolean {
    if (this.userInfo.popContent && this.userInfo.popContent.id !== 37) {
      this.checkedAgree = true
    }
    if (
      BaseStore.popUpShow &&
      this.userInfo.popContent &&
      this.userInfo.popContent.popContent
    ) {
      return true
    }
    return false
  }

  // 商户自己的信息
  get userInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  getNumPages (): void {
    const loadingTask = Pdf.createLoadingTask(this.pdfUrl)
    loadingTask.promise.then(pdf => {
      console.log('pdf')
      console.log(pdf)
      this.pdfPageAll = pdf.numPages
    }).catch(err => {
      console.error('pdf 加载失败', err)
    })
  }

  handleScroll (e): void {
    const scrollTop = e.target.scrollTop
    const domHeight = e.target.clientHeight
    const scrollHeight = e.target.scrollHeight
    if (scrollHeight - scrollTop - domHeight < (domHeight / 2)) {
      if (this.time) {
        // clearTimeout(this.time)
        return
      }
      console.log('要触底了啊')
      this.time = setTimeout(() => {
        if (this.pdfPageAll > this.pdfPage) {
          this.pdfPage++
          this.PageAll++
        }
        if (this.time) {
          clearTimeout(this.time)
          this.time = null
        }
      }, 300)
    }
  }

  // 点击图片类型的弹框内容
  clickPopUp (popContent): void {
    if (/^http/.test(popContent.popLink)) {
      window.open(popContent.popLink)
    } else if (popContent.popLink) {
      this.$router.push(popContent.popLink)
    }
    BaseStore.SET_POP_UP(false)
  }

  mounted (): void {
    if (this.userInfo.popContent && this.userInfo.popContent.popType === 2) {
      this.pdfUrl = this.userInfo.popContent.popContent
      this.getNumPages()
    }
  }
}

